/**
 * router/index.ts
 *
 * Automatic routes for `./src/pages/*.vue`
 */

// Composables
import { createRouter, createWebHistory } from 'vue-router/auto'
import { setupLayouts } from 'virtual:generated-layouts'
import { routes } from 'vue-router/auto-routes'


// const nestedRoute = routes.find((route) => route.path === '/iframe')

// if (nestedRoute) {
//   nestedRoute.meta = nestedRoute.meta ?? {}
//   nestedRoute.meta.layout = 'iframe'
// }


const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: setupLayouts(routes),
})

// // ✅ Global Navigation Guard: Preserve `ipAddress` & `tokenId` for all routes (nested & top-level)
// router.beforeEach((to, from, next) => {
//   const paramsToPreserve = ["ipAddress", "tokenId"];

//   // Extract missing parameters from `from.query` (previous route)
//   const missingParams = { ...to.query }; // Start with current query params

//   paramsToPreserve.forEach(param => {
//     if (from.query[param] && !to.query[param]) {
//       missingParams[param] = from.query[param]; // Add missing param
//     }
//   });

//   // If any query params are missing, redirect with merged params
//   if (JSON.stringify(to.query) !== JSON.stringify(missingParams)) {
//     next({
//       path: to.fullPath.split("?")[0], // Keep full path (nested or not)
//       query: missingParams, // Merge missing query params
//       replace: true // Avoid pushing duplicate history entries
//     });
//   } else {
//     next(); // Proceed as usual if no changes are needed
//   }
// })

// Workaround for https://github.com/vitejs/vite/issues/11804
router.onError((err, to) => {
  if (err?.message?.includes?.('Failed to fetch dynamically imported module')) {
    if (!localStorage.getItem('vuetify:dynamic-reload')) {
      localStorage.setItem('vuetify:dynamic-reload', 'true')
      location.assign(to.fullPath)
    }
  }
})

router.isReady().then(() => {
  localStorage.removeItem('vuetify:dynamic-reload')
})

export default router
